VLW.controllers.defaultPage = class extends VLW.controllers.base_mc {
	constructor(el, config) {
		super(el, config);
		TweenMax.set(this.getElementIntro(), {opacity: 0});
		this.copyLogo();
		broadCaster.MENU_HOVER.add(this.onMenuHover);
		broadCaster.MENU_LEAVE.add(this.onMenuLeave);
	}

	getElementIntro() {
		return this.mainElementJS;
	}

	copyLogo() {
		if(CONFIG.ISTABLET ||VERSION_SMARTP) {
			this.qs("._logo") && (this.qs("._logo").innerHTML = "<img src='/images/logo2x.png'/>");
		}else{
			this.qs("._logo") && (this.qs("._logo").innerHTML = document.querySelector("._mainLogo").innerHTML);
		}
		
	}

	static setStyleMenuHover(cssClass) {
		document.querySelector("._menuHover").className = (document.querySelector("._menuHover").className.split(" ").filter((elt) => !elt.match(/^color/))).join(" ");
		document.querySelector("._menuHover").classList.add(cssClass);
	}
	static getClassName(){
		return this.name;
	}

	onMenuHover() {
		TweenMax.killTweensOf(this.mainElementJS);
		TweenMax.to(this.mainElementJS, .5, {opacity: 0});
	}

	onMenuLeave() {
		
		TweenMax.to(this.mainElementJS, .5, {opacity: 1, ease: Power2.easeIn,delay:.5});
	}

	intro() {
		super.intro();

	}

	outro() {
		super.outro();
	}
};